export default __webpack_public_path__ + "static/media/unknown-nft.1d1bca96.gif";